import React, { useContext, useCallback, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { CheckboxGroupContext } from './RadioGroup';
import './index.scss';

interface Props {
  onChange?: NoopFunc;
  name: string;
}

const CheckboxItem: React.FC<PropsWithChildren<Props>> = props => {
  const { children, name } = props;
  const { value, onChange } = useContext(CheckboxGroupContext);

  const handleClick = useCallback(() => {
    onChange && onChange(name);
  }, [name, onChange]);

  return (
    <div className={classNames('my-radio-item', { checked: value === name })} onClick={handleClick}>
      {children}
    </div>
  );
};

export default CheckboxItem;
